var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconGarage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4046 8.45236C21.3624 8.45236 21.3248 8.44298 21.2873 8.41953L11.3196 2.64996L1.3518 8.41953C1.28144 8.46174 1.18763 8.46174 1.11727 8.41953C1.04691 8.37731 1 8.30226 1 8.21783V7.07329C1 6.98886 1.04691 6.91381 1.11727 6.87159L11.2023 1.03166C11.2773 0.989446 11.3665 0.989446 11.4368 1.03166L21.5218 6.87159C21.5922 6.91381 21.6391 6.98886 21.6391 7.07329V8.21783C21.6391 8.30226 21.5922 8.37731 21.5218 8.41953C21.4843 8.44298 21.4468 8.45236 21.4046 8.45236ZM11.3196 2.14336C11.3618 2.14336 11.3993 2.15274 11.4368 2.17619L21.17 7.80973V7.20463L11.3196 1.50542L1.46907 7.20463V7.80973L11.2023 2.17619C11.2398 2.15274 11.2773 2.14336 11.3196 2.14336Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2179 20.9999H2.41666C2.28532 20.9999 2.18213 20.8967 2.18213 20.7654V7.53288C2.18213 7.40154 2.28532 7.29834 2.41666 7.29834C2.548 7.29834 2.6512 7.40154 2.6512 7.53288V20.5308H19.9834V7.53288C19.9834 7.40154 20.0866 7.29834 20.2179 7.29834C20.3492 7.29834 20.4524 7.40154 20.4524 7.53288V20.7701C20.4524 20.8967 20.3492 20.9999 20.2179 20.9999Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.074 21C17.9427 21 17.8395 20.8969 17.8395 20.7655V9.35771C17.8395 9.22168 17.7316 9.11379 17.5956 9.11379H5.04795C4.91192 9.11379 4.80403 9.22168 4.80403 9.35771V20.7655C4.80403 20.8969 4.70084 21 4.5695 21C4.43816 21 4.33496 20.8969 4.33496 20.7655V9.3624C4.33496 8.96838 4.65393 8.64941 5.04795 8.64941H17.5956C17.9896 8.64941 18.3086 8.96838 18.3086 9.3624V20.7702C18.3086 20.8968 18.2007 21 18.074 21Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.679 7.25633H8.96012C8.82878 7.25633 8.72559 7.15313 8.72559 7.02179V5.44572C8.72559 5.31438 8.82878 5.21118 8.96012 5.21118H13.679C13.8103 5.21118 13.9135 5.31438 13.9135 5.44572V7.02179C13.9135 7.15313 13.8103 7.25633 13.679 7.25633ZM9.19466 6.78726H13.4444V5.68025H9.19466V6.78726Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3195 7.25633C11.1882 7.25633 11.085 7.15313 11.085 7.02179V5.44572C11.085 5.31438 11.1882 5.21118 11.3195 5.21118C11.4508 5.21118 11.554 5.31438 11.554 5.44572V7.02179C11.554 7.15313 11.4508 7.25633 11.3195 7.25633Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0743 10.5257H4.5651C4.43376 10.5257 4.33057 10.4225 4.33057 10.2912C4.33057 10.1598 4.43376 10.0566 4.5651 10.0566H18.0743C18.2057 10.0566 18.3089 10.1598 18.3089 10.2912C18.3089 10.4225 18.201 10.5257 18.0743 10.5257Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0743 11.9329H4.5651C4.43376 11.9329 4.33057 11.8297 4.33057 11.6984C4.33057 11.5671 4.43376 11.4639 4.5651 11.4639H18.0743C18.2057 11.4639 18.3089 11.5671 18.3089 11.6984C18.3089 11.8297 18.201 11.9329 18.0743 11.9329Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0743 13.3402H4.5651C4.43376 13.3402 4.33057 13.237 4.33057 13.1056C4.33057 12.9743 4.43376 12.8711 4.5651 12.8711H18.0743C18.2057 12.8711 18.3089 12.9743 18.3089 13.1056C18.3089 13.237 18.201 13.3402 18.0743 13.3402Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.218 19.8179H18.0744C17.943 19.8179 17.8398 19.7148 17.8398 19.5834C17.8398 19.4521 17.943 19.3489 18.0744 19.3489H20.2227C20.3541 19.3489 20.4573 19.4521 20.4573 19.5834C20.4573 19.7148 20.3494 19.8179 20.218 19.8179Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M4.56501 19.8179H2.41666C2.28532 19.8179 2.18213 19.7148 2.18213 19.5834C2.18213 19.4521 2.28532 19.3489 2.41666 19.3489H4.56501C4.69635 19.3489 4.79954 19.4521 4.79954 19.5834C4.79954 19.7148 4.69635 19.8179 4.56501 19.8179Z",
    fill: "#646262",
    stroke: "#646262",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGarage);
export default __webpack_public_path__ + "static/media/icon-garage.fa64ef877b35daafc78ad15a16cd01d1.svg";
export { ForwardRef as ReactComponent };